import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-select-filter-input',
  templateUrl: './select-filter-input.component.html',
  styleUrls: ['./select-filter-input.component.scss']
})

export class SelectFilterInputComponent implements OnInit {
  @Input() options: { nome: string, valor: string | number }[] = [];
  @Input() label: string = '';
  @Input() initialValue: string = '';
  @Input() searchTerm: string = '';

  @Output() selectOption = new EventEmitter<{ nome: string, valor: string | number }>();
  @Output() clearSelection = new EventEmitter<void>();

  filteredOptions: { nome: string, valor: string | number }[] = [];
  showDropdown: boolean = false;
  hasInteracted: boolean = false;
  selectedValue: string | number = '';

  constructor(private elementRef: ElementRef) {}

  private trySetInitialDisplay() {
    if (this.options?.length && this.initialValue != null) {
      const match = this.options.find(opt => opt.valor === this.initialValue);
      if (match) {
        this.searchTerm = match.nome;
      }
    }
  }

  ngOnInit(): void {
    this.filteredOptions = this.options;
  }

  ngOnChanges(): void {
    this.trySetInitialDisplay();
  }

 clearInput() {
    this.searchTerm = '';
    this.selectedValue = '';
    this.onInputBlur();
  }

  onInputBlur(): void {
    const match = this.options.find(opt => opt.nome.toLowerCase() === this.searchTerm.toLowerCase());
    if (!match) {
      this.searchTerm = '';
      this.selectedValue = '';
      this.clearSelection.emit();
    } else {
      this.selectItem(match);
    }
  }

  onInputFocus(): void {
    this.filteredOptions = this.options;
    this.showDropdown = true;
  }

  onInputChange(): void {
    const term = this.searchTerm.toLowerCase();
    this.filteredOptions = this.options.filter(opt =>
      opt.nome?.toLowerCase()?.includes(term)
    );
    this.showDropdown = true;

    if (!this.searchTerm.trim()) {
      this.clearSelection.emit();
    }
  }

  selectItem(option: { nome: string, valor: string | number }): void {
    this.searchTerm = option.nome;
    this.showDropdown = false;

    if (this.selectedValue !== option.valor) {
      this.selectedValue = option.valor;
      this.selectOption.emit(option);
    }
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.showDropdown = false;
    }
  }
}
